import { bcs } from "@mysten/bcs";
import {
  Address,
  Authenticator,
  BitcoinAuthPayload,
  CallFunction,
  FunctionId,
  ModuleId,
  MoveAction,
  MultiChainAddress,
  ObjectId,
  raw,
  RoochTransaction,
  RoochTransactionData,
  ScriptCall
} from "./bcs.js";
import { BcsType } from "@mysten/bcs";
import { Args } from "./args.js";
import { Serializer } from "./serializer.js";
import {} from "./types.js";
const RoochBcs = {
  U8: bcs.u8(),
  U16: bcs.u16(),
  U32: bcs.u32(),
  U64: bcs.u64(),
  U128: bcs.u128(),
  U256: bcs.u256(),
  Bool: bcs.bool(),
  Raw: raw,
  String: bcs.string(),
  Address,
  MultiChainAddress,
  ObjectId,
  BitcoinAuthPayload,
  ModuleId,
  FunctionId,
  ScriptCall,
  CallFunction,
  MoveAction,
  RoochTransactionData,
  Authenticator,
  RoochTransaction,
  ...bcs
};
export {
  Args,
  BcsType,
  RoochBcs,
  Serializer,
  RoochBcs as bcs
};
//# sourceMappingURL=index.js.map
